import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { tables } from '@/utils/tableProperties';
import { genericError } from '@/utils/alerts.service';

export const table = {
  namespaced: true,
  state: {
    // entries of the table
    rows: [],

    // search bar
    query: '',

    sortBy: '',

    // these will be columns in the table
    columns: tables.contactRequests.fields,

    filters: {
      name: { value: '', keys: ['resellerName'] },
      projectStatus: { value: '', keys: ['projectStatus'] },
    },
    pageSize: 50,
    count: 0,
    timeout: null,
    loading: false,
  },
  getters: {
    getColumns(state) {
      return state.columns;
    },
    getRows(state) {
      return state.rows;
    },
    getFilters(state) {
      return state.filters;
    },
  },
  mutations: {
    setQuery(state, query) {
      state.query = query;
    },
    updateFilter(state, { fields, type, value }) {
      state.filters[type] = { value: value, keys: fields };
    },
    setContactData(state, data) {
      state.rows = data;
    },
    setCount(state, count) {
      state.count = count;
    },
    setLoading(state, bool) {
      state.loading = bool;
    },
    setSort(state, sortBy) {
      state.sortBy = sortBy;
    },
  },
  actions: {
    sortResults({ commit, dispatch }, sortKey) {
      commit('setSort', sortKey);
      dispatch('fetchContactData', 1);
    },
    resetQueryAndFilter({ dispatch, commit, state }) {
      commit('setQuery', '');
      for (const [key, value] of Object.entries(state.filters)) {
        if (value.value !== '') {
          commit('updateFilter', {
            fields: value.keys,
            type: key,
            value: '',
          });
        }
      }
      dispatch('fetchContactData', 1);
    },
    updateQueryAndFilter({ commit, dispatch, state }, { fields, value, type }) {
      if (type === 'name') {
        commit('setQuery', value);
      }
      commit('updateFilter', { fields, type, value });

      clearTimeout(state.timeout);
      state.timeout = setTimeout(() => {
        dispatch('fetchContactData', 1);
      }, 500);
    },
    async fetchContactData({ dispatch, commit, state }, page = 1) {
      commit('setLoading', true);
      let filterQuery =
        '&name=' +
        encodeURIComponent(state.filters.name.value) +
        '&project_status=' +
        encodeURIComponent(state.filters.projectStatus.value);
      return vendorDashboardAPI
        .getContactRequests(
          page,
          state.pageSize,
          state.query,
          filterQuery,
          state.sortBy
        )
        .then(data => {
          commit('setCount', data.count);
          commit('setContactData', data.results);
          commit('setLoading', false);
          return true;
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
